import { useDevCredentials } from '../../context/DevCredentialsContext';

/**
 * Brand mark above the popup header. When an OEM has uploaded a brand
 * record in the developer console (queried by the popup via console-api
 * keyed on `clientId`), renders the OEM's `logoUrl`. Otherwise renders
 * the default DIMO wordmark.
 *
 * The DIMO SVG is kept inline so the popup chrome works zero-network
 * (no flash of unrendered text while a logo asset loads) and is
 * unchanged for the common case where no brand is configured.
 */
export const Logo = () => {
  const { oemBrand } = useDevCredentials();
  const logoUrl = oemBrand?.logoUrl ?? null;

  if (logoUrl) {
    return (
      <div className="flex justify-center items-center h-[40px]">
        <img
          src={logoUrl}
          alt={oemBrand?.name ? `${oemBrand.name} logo` : 'OEM logo'}
          className="max-h-[40px] max-w-[160px] object-contain"
        />
      </div>
    );
  }

  return (
    <div className="flex justify-center h-[40px]">
      <svg
        width="71"
        height="17"
        viewBox="0 0 71 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3154_1597)">
          <path d="M24.0271 0.931091H19.6265V16.6455H24.0271V0.931091Z" fill="black" />
          <path
            d="M36.3629 16.7677C33.6641 16.7677 31.4694 14.5642 31.4694 11.8548L31.4757 5.68065C31.4757 5.20157 31.087 4.81133 30.6098 4.81133C30.1326 4.81133 29.7439 5.20157 29.7439 5.68065V16.6471H25.7178V5.67906C25.7178 2.97115 27.9125 0.7677 30.6098 0.7677C33.307 0.7677 35.5018 2.97115 35.5018 5.67906V7.70008L35.497 7.91583V11.8548C35.497 12.3322 35.8842 12.7225 36.3614 12.7225C36.7121 12.7225 37.0234 12.5194 37.1514 12.2069L40.5455 3.86427L40.5613 3.8262C41.6263 1.29754 43.4197 0.7677 44.7375 0.7677H44.8244C47.5216 0.7677 49.7164 2.97115 49.7164 5.67906V16.6471H45.6887V5.67906C45.6887 5.31896 45.4738 5.0001 45.1388 4.87002C45.0377 4.83036 44.9318 4.80974 44.8244 4.80974C44.4657 4.80974 44.1481 5.02707 44.0185 5.36338L40.4143 14.155C39.7475 15.7794 38.3175 16.7265 36.4799 16.7661H36.3645L36.3629 16.7677Z"
            fill="black"
          />
          <path
            d="M0 12.4465H10.2059C12.3501 12.4465 14.0297 10.8347 14.0297 8.77722C14.0297 6.71971 12.3153 4.96837 10.2075 4.96837H5.06582C4.5823 4.96837 4.1857 5.36655 4.1857 5.85198V11.3376H0V5.67906C0 2.97115 2.19477 0.7677 4.892 0.7677H10.4208C14.8356 0.7677 18.4272 4.3608 18.4272 8.77563C18.4272 13.1905 14.9099 16.6456 10.4208 16.6456H0V12.4449V12.4465Z"
            fill="black"
          />
          <path
            d="M58.9378 16.6456C54.4487 16.6456 50.9314 13.1889 50.9314 8.77563C50.9314 4.35921 54.523 0.7677 58.9378 0.7677H62.7032C67.118 0.7677 70.7096 4.3608 70.7096 8.77563C70.7096 13.1905 67.1923 16.6456 62.7032 16.6456H58.9378ZM62.4883 12.4465C64.6325 12.4465 66.3121 10.8347 66.3121 8.77722C66.3121 6.71971 64.5977 4.96837 62.4899 4.96837H59.1543C57.0464 4.96837 55.332 6.67688 55.332 8.77722C55.332 10.8347 57.0116 12.4465 59.1558 12.4465H62.4914H62.4883Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_3154_1597">
            <rect
              width="70.7097"
              height="16"
              fill="white"
              transform="translate(0 0.7677)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Logo;
